<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <ValidationObserver ref="form">
            <b-row>
              <b-col cols="12" class="mt-3 mb-1">
                <b-form-group>
                  <label for="domTH"
                    >เนื้อหาภาษาไทย </label
                  >
                  <ValidationProvider
                    name="ครั้งที่"
                    v-slot="{ errors }"
                  >
                    <vue-editor v-model="editorDomData.domTh"></vue-editor>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mt-3 mb-1 align-item-bottom">
                <b-form-group>
                  <label for="domEN"
                    >เนื้อภาษาอังกฤษ </label
                  >
                  <ValidationProvider
                    name="ปี"
                    v-slot="{ errors }"
                  >
                    <vue-editor v-model="editorDomData.domEn"></vue-editor>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="d-flex justify-content-between">
                <b-button variant="secondary" @click="onCancelBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button variant="primary" @click="onSubmitBtnClicked">
                  บันทึกข้อมูล
                </b-button>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as editorDomStore from "@/store/api/editorDom/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as lang from "vuejs-datepicker/src/locale";

import { VueEditor } from "vue2-editor";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";


extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    extend,
    VueEditor,
  },
  data() {
    return {
      editorDomData: {
        domTh: '',
        domEn: '',
        isActive: true,
      },
      attachFiles: [],
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      languages: lang.th,
    };
  },
  mounted () {
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
    } else {
      const id = this.$route.query.id;
      this.geteditorDomById(id);
    }
  },
  methods: {
    geteditorDomById(id) {
      const _this = this;

      editorDomStore
        .getById(id)
        .then((response) => {
          _this.editorDomData = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            editorDomStore
              .updateItem(_this.editorDomData)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "EditorDom",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "editorDom" }).href, "_self");
    },
  },
};
</script>

<style lang="scss"></style>
